import { useEffect, useMemo, useState } from "react";
import { useStore } from "../../../../store/store";
import { PaymentFrequencyTypeEnum } from "../../../../types/PaymentFrequencyTypeEnum";
import { formatNumber } from "../../../../utils/formatNumber";
import { Container, Description, Headline, Info, InfoText, LIlist, OLlist, Product, ProductExtra, ProductFree, ProductFreeExtra, ProductHeadline, ProductRow, ProductRowHeadline, ProductrowSalaryinsuranceUnion, SalaryinsuranceUnionSpan, Sumup, SumupText, UnionAndInsurance } from "./Reciept.style";
import { PaymentTypeEnum } from "../../../../types/PaymentTypesEnum";
import PaymentStep from "../../Steps/PaymentStep";
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes";

interface Props {
  info?: string;
  basePrice: boolean;
  hidden?: boolean;
}

export default function Reciept({ info, basePrice, hidden }: Props) {
  const payload = useStore.usePayload();
  const offerEnabled = useStore.useOfferEnabled();
  const translations = useStore.useTranslations();
  const setFullAmountPayment = useStore.useSetFullAmountPayment();
  const fullAmountPayment = useStore.useFullAmountPayment();
  const bsPaymentFee = useStore.useBsPaymentFee();
  const isDesktop = useStore.useIsDesktop();
  const mobilePayPaymentFee = useMemo(() => {
    return payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly
      ? Number(translations?.paymentStep.mobilePay.quarterlyServiceFee)
      : Number(translations?.paymentStep.mobilePay.monthlyServiceFee);
  }, [payload.paymentFrequency, translations]);
 /*  
Check for BSpaymentFee moved to previous step YourConsentStep because of OI splittest
 const [bsPaymentFee, setBsPaymentFee] = useState(0);

 useEffect(() => {
    if (payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly && payload.wantsUnemploymentBenefits) {
      console.log("1")
      setBsPaymentFee(Number(translations?.paymentStep.bs.quarterlyServiceFee))
    } else if (payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly && payload.wantsUnemploymentBenefits) {
      console.log("2")
      setBsPaymentFee(Number(translations?.paymentStep.bs.monthlyServiceFee))
    } else {
      console.log("3")
      setBsPaymentFee(0)
    }
  }, [payload.paymentFrequency, payload.wantsUnemploymentBenefits]);

  console.log("bsPaymentFee: ", bsPaymentFee) */
  const unemploymentbenefitsInsuranceAndUnionPrice = Number(translations?.productsStep.salaryInsuranceAndUnion.price);
  const insuranceAndUnionPrice = Number(translations?.productsStep.salaryInsuranceAndUnion.singlePrice);

  //Price of unemploymentBenefits pr. month based on occupation (if the product is not choosen it returns 0)
  const unemploymentInsurancePrice = (payload.wantsUnemploymentBenefits && payload.occupation !== "Student" && payload.occupation !== "SelfEmployed") ? Number(translations?.summaryStep.unemploymentInsurance.price) : payload.wantsUnemploymentBenefits && payload.occupation === "SelfEmployed" ? Number(translations?.productsStep.unemploymentInsurance.price_selfemployed) : 0;

  //Price of union pr.month (if the product is not choosen it returns 0)
  let unionPrice: number;
  if(payload.wantsUnion) {
    if(offerEnabled && payload.wantsUnemploymentBenefits && payload.occupation !== "Student") {
      unionPrice = 0;
    } else if ((offerEnabled && !payload.wantsUnemploymentBenefits) || !offerEnabled || (offerEnabled && payload.occupation === "Student")) {
      unionPrice = Number(translations?.summaryStep.union.price);
    }
  } else {
    unionPrice = 0
  }

  //Monthly price without BsPaymentFee
  const basicPrice = useMemo(() => {

    const totalAmountPrice = unemploymentInsurancePrice + unionPrice;

    return totalAmountPrice;

  }, [payload, translations]);

  //Full price either monthly or quarterly with possible BsPaymentFee
  const recieptPrice = useMemo(() => {
    let fullPrice = unemploymentInsurancePrice

    if(payload.wantsUnemploymentBenefits) {
      fullPrice = payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly ? (unemploymentInsurancePrice * 3) : unemploymentInsurancePrice;
    }

    if(payload.wantsUnion) {
      fullPrice = payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly ? (unemploymentInsurancePrice + unionPrice) : ((unemploymentInsurancePrice * 3) + (unionPrice * 3));
    }

    if(payload.wantsHRJura || payload.wantsBasic) {
      fullPrice = payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly ? (unemploymentInsurancePrice) : (unemploymentInsurancePrice * 3);
    } 

    if(payload.wantsSalaryInsuranceAndUnion) {
      fullPrice = payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly ? unemploymentbenefitsInsuranceAndUnionPrice : (unemploymentbenefitsInsuranceAndUnionPrice * 3);
    }

    return fullPrice

    
  }, [payload])

//Find totalAmount based on const basePrice
const totalAmount = useMemo(() => {
  if(basePrice) {
    return basicPrice;
  } else {
    setFullAmountPayment(recieptPrice)
    return recieptPrice;
  }
}, [basicPrice, recieptPrice, basePrice, payload.wantsUnemploymentBenefits, payload.wantsUnion])

  return (
    <>
      <Container style={hidden ? { display: "none" } : undefined}>
        {!payload.wantsSalaryInsuranceAndUnion && (
        <Headline>{translations?.reciept.title}</Headline>
        )}
        {!payload.wantsUnemploymentBenefits && !payload.wantsSalaryInsurance && !payload.wantsUnion && !payload.wantsBasic && !payload.wantsHRJura && <Description>{translations?.reciept.description}</Description>}
        {payload.wantsUnemploymentBenefits && payload.occupation !== "Student" && !payload.wantsSalaryInsuranceAndUnion && (
          <ProductRow>
            <Product>{translations?.productsStep.unemploymentInsurance.title}</Product>
            {(basePrice || payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly) &&
            <Product>
                {payload.occupation === "SelfEmployed" ? `${translations?.productsStep.unemploymentInsurance.price_selfemployed} ${translations?.general.krPerMonth}` : `${translations?.productsStep.unemploymentInsurance.price} ${translations?.general.krPerMonth}`}
            </Product>
            }
           {(!basePrice && payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly) &&
            <Product>
                {payload.occupation === "SelfEmployed" ? `${Number(translations?.productsStep.unemploymentInsurance.price_selfemployed) * 3} ${translations?.general.krPerQuarterly}` : `${Number(translations?.productsStep.unemploymentInsurance.price) * 3} ${translations?.general.krPerQuarterly}`}
            </Product>
            }
          </ProductRow>
        )}
        {payload.wantsUnemploymentBenefits && payload.occupation === "Student" && (
          <ProductRow>
            <Product>{translations?.productsStep.unemploymentInsurance.title}</Product>
            <Product>{translations?.productsStep.unemploymentInsurance.price_student}</Product>
          </ProductRow> 
        )}
        {payload.wantsSalaryInsurance && 
          <ProductRow>
            <Product>{translations?.summaryStep.salaryGuarantee.title}</Product>
            <ProductExtra>{translations?.summaryStep.salaryGuarantee.price}</ProductExtra>
          </ProductRow>
        }
        
        {payload.wantsUnion && (
          <ProductRow>
            <Product>{translations?.productsStep.union.title}</Product>
            {payload.occupation === "Student" && (
              <Product>{translations?.productsStep.union.price} {translations?.general.krPerMonth}</Product>
            )}
            {(offerEnabled && payload.wantsUnemploymentBenefits && payload.occupation !== "Student") && (              
              <div>
                <ProductFree>{translations?.reciept.unionOfferText}</ProductFree>
                  {(payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly) && (
                    <ProductFreeExtra>
                      Herefter: {translations?.productsStep.union.price} {translations?.general.krPerMonth}
                    </ProductFreeExtra>
                  )}
                   {(payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly) && (
                    <ProductFreeExtra>
                      Herefter: {(Number(translations?.productsStep.union.price) * 3)} {translations?.general.krPerQuarterly}
                    </ProductFreeExtra>
                  )}
              </div>
            )}
            {(!offerEnabled || (offerEnabled && !payload.wantsUnemploymentBenefits && payload.occupation !== "Student")) && (basePrice || payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly) && 
              <Product>
                {translations?.productsStep.union.price} {translations?.general.krPerMonth}
              </Product>
            }
            {(!offerEnabled || (offerEnabled && !payload.wantsUnemploymentBenefits)) && (!basePrice && payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly) &&
              <Product>
                {Number(translations?.productsStep.union.price) * 3 } {translations?.general.krPerQuarterly}
              </Product>
            }
          </ProductRow>
        )}
        {payload.wantsBasic &&
          <ProductRow>
            <Product>{translations?.summaryStep.basic.title}</Product>
            <Product>{translations?.summaryStep.basic.price}</Product>
          </ProductRow>
        }
        {payload.wantsHRJura &&
          <ProductRow>
            <Product>{translations?.summaryStep.hrJura.title}</Product>
            <Product>{translations?.summaryStep.hrJura.price}</Product>
          </ProductRow>
        }
       {payload.wantsSalaryInsuranceAndUnion && !isDesktop && (
        <>
          <ProductRow>
            <UnionAndInsurance>Du har valgt: {translations?.productsStep.salaryInsuranceAndUnion.title}</UnionAndInsurance>
            <Product><span><b>{formatNumber(totalAmount)} {translations?.general.krPerMonth}</b></span></Product>
          </ProductRow>
          <ProductRow>
            <ProductHeadline><b>Sådan foregår betalingen:</b></ProductHeadline>
          </ProductRow>
          <ProductRow>
            <OLlist>
              <LIlist>Vi opretter dig i a-kassen.<br/>Du modtager en betalingsanmodning i MobilePay på <b>{translations?.productsStep.unemploymentInsurance.price} kr.</b></LIlist>
              <LIlist><b>Du modtager både en mail og sms fra Howden i løbet af de næste 5 hverdage, hvor du selv skal tilmelde dig Betalingsservice. Det er vigtigt, da din lønsikring ellers kan gå i restance</b></LIlist>
            </OLlist>
          </ProductRow>
        </>
        )}
        {!payload.wantsSalaryInsuranceAndUnion && (
          <Sumup>
            <SumupText>I alt</SumupText>
            <SumupText>
              {formatNumber(totalAmount)} 
              {(payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly) && (
                <span> kr.</span>
              )}
              {(payload.paymentFrequency === PaymentFrequencyTypeEnum.Quarterly) && (
                <span> kr.</span>
              )}
            </SumupText>
          </Sumup>
        )}
        <InfoText>Der er 14 dages fortrydelsesret på din indmeldelse</InfoText>    
        {info && payload.paymentType === PaymentTypeEnum.BSPAYMENT && <Info>Din betaling tilknyttes betalingsservice. Opkrævningsgebyr {formatNumber(bsPaymentFee)} {payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly ? translations?.general.krPerMonth : translations?.general.krPerQuarterly }</Info>}
        {info && payload.paymentType === PaymentTypeEnum.MOBILE_PAY && <Info>Din betaling tilknyttes MobilePay. Opkrævningsgebyr {formatNumber(mobilePayPaymentFee)} {payload.paymentFrequency === PaymentFrequencyTypeEnum.Monthly ? translations?.general.krPerMonth : translations?.general.krPerQuarterly }</Info>}
      </Container>
    </>
  );
}
